import { render } from "./edit_dept.vue?vue&type=template&id=0040a9fe"
import script from "./edit_dept.vue?vue&type=script&lang=js"
export * from "./edit_dept.vue?vue&type=script&lang=js"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__